import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import ClickToChatAppComponent from "./components/click-to-chat-app.vue";

import "@paradym-libraries/bootstrap-iso/resources/bootstrap-iso.css";
import ChatToSms from "./libs/chatService";

import AppStore from "./app-state/store";

// Setup vue to use validation plugin
Vue.use(VeeValidate, { events: "" });

// Custom error messages
const customDictionary = {
    custom: {
        email: {
            email: "Please enter a valid email.",
            required: "Please enter a valid email."
        },
        message: {
            required: "Please enter your message."
        },
        name: {
            required: "Please enter your name."
        },
        phone: {
            regex: "Please enter your 10 digit phone number including area code.",
            required: "Please enter your 10 digit phone number including area code."
        }
    }
};

Validator.localize("en", customDictionary);

Vue.config.devtools = process.env.NODE_ENV === "development";

export const eventBus = new Vue();
export const config = {};

export default {
    run: function (config) {
        Vue.prototype.$appSettings = config.appSettings;
        Vue.prototype.$chatService = new ChatToSms(config.appSettings.vtWebSvcUrl);
        Vue.prototype.$appStore = AppStore(config.agent, config.tour, config.socialMediaPost, config.browser);
        Vue.prototype.$appBranding = {
            backgroundColor: config.appSettings.brandingBackgroundColor,
            foregroundColor: config.appSettings.brandingForegroundColor
        };

        return new Vue({
            render: (h) => h(ClickToChatAppComponent)
        }).$mount("#click-to-chat-app");
    }
};
